<template>
  <div class='mainConent'>
    <header class='header'>
      <img :src="imgUrls+'logo_main_white.png'" alt="">
    </header>
    <section class='centent'>
      <div class='work_yq animated flipInX'></div>
      <div class='work_icon work_people'>
        <div class='work_icon Student_icon adimate_Float' @click='gonavgin("/parent")'></div>
        <div class='work_icon Teacher_icon adimate_teacher' @click='gonavgin("/parent")'></div>
        <div class='work_icon Parent_icon adimate_parent' @click='gonavgin("/parent")'></div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        imgUrls: this.$imgUrls,

      }
    },
    created() {

    },
    mounted() {
      let _this = this;
      _this.$nextTick(function() {
        // let winHeight = document.documentElement.clientHeight || document.dody.clientHeight;
        // document.getElementsByClassName('mainConent')[0].style.height = winHeight + 'px';
      })
    },
    methods: {
      gonavgin(val) {
        if (!val) {
          return
        }
        this.$router.push(val);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mainConent {
    background-image: bkMyUrl('resumptionWork_main-icon.png');
    background-size: cover;
    min-height: 16.613333rem;
  }

  .header {
    height: 1.666666rem;
    background-color: #fff;
    text-align: center;
    padding-top: 0.466666rem;
    box-sizing: border-box;

    img {
      width: 3.16rem;
      height: 0.893333rem;
      margin: auto;
    }
  }

  .work_icon {
    position: absolute;
  }

  .centent {
    position: relative;
    height: calc(100% - 1.666666rem);

    .work_yq {
      width: 8.2rem;
      height: 7.906666rem;
      margin-top: 0.133333rem;
      margin: auto;
      background-image: bkMyUrl('resumptionWork_yq_icon.png');
      background-size: cover;
    }

    .work_people {
      width: 8.84rem;
      height: 7.96rem;
      background-image: bkMyUrl('resumptionWork_people_icon.png');
      background-size: cover;
      bottom: 2.2%;
      left: 0.933333rem;

      .Student_icon {
        background-image: bkMyUrl('resumptionWork_Student_icon.png');
        background-size: cover;
        width: 1.146666rem;
        height: 1.893333rem;
        top: 0.346666rem;
        left: 3.64rem;
        cursor: pointer;
      }

      .Teacher_icon {
        background-image: bkMyUrl('resumptionWork_Teacher_icon.png');
        background-size: cover;
        width: 1.373333rem;
        height: 2.36rem;
        right: 0;
        top: 1.6rem;
        cursor: pointer;
      }

      .Parent_icon {
        background-image: bkMyUrl('resumptionWork_Parent_icon.png');
        background-size: cover;
        width: 1.253333rem;
        height: 1.733333rem;
        left: -0.6rem;
        top: 1.613333rem;
        cursor: pointer;
      }


    }
  }

  .adimate_Float {
    animation: anim_Float 1.95s linear infinite;
    -moz-animation: anim_Float 1.95s linear infinite;
    -webkit-animation: anim_Float 1.95s linear infinite;
    -o-animation: anim_Float 1.95s linear infinite;
  }

  .adimate_teacher {
    animation: anim_teacher 1.95s linear infinite;
    -moz-animation: anim_teacher 1.95s linear infinite;
    -webkit-animation: anim_teacher 1.95s linear infinite;
    -o-animation: anim_teacher 1.95s linear infinite;
  }

  .adimate_parent {
    animation: anim_parent 1.95s linear infinite;
    -moz-animation: anim_parent 1.95s linear infinite;
    -webkit-animation: anim_parent 1.95s linear infinite;
    -o-animation: anim_parent 1.95s linear infinite;
  }

  @keyframes anim_Float {
    0% {
      top: 0.346666rem;
    }

    50% {
      top: 0.446666rem;
    }

    100% {
      top: 0.346666rem;
    }
  }

  @-moz-keyframes anim_Float {
    0% {
      top: 0.346666rem;
    }

    50% {
      top: 0.446666rem;
    }

    100% {
      top: 0.346666rem;
    }
  }

  @-webkit-keyframes anim_Float {
    0% {
      top: 0.346666rem;
    }

    50% {
      top: 0.446666rem;
    }

    100% {
      top: 0.346666rem;
    }
  }

  //teaher
  @keyframes anim_teacher {
    0% {
      top: 1.6rem;
    }

    50% {
      top: 1.7rem;
    }

    100% {
      top: 1.6rem;
    }
  }

  @-moz-keyframes anim_teacher {
    0% {
      top: 1.6rem;
    }

    50% {
      top: 1.7rem;
    }

    100% {
      top: 1.6rem;
    }
  }

  @-webkit-keyframes anim_teacher {
    0% {
      top: 1.6rem;
    }

    50% {
      top: 1.7rem;
    }

    100% {
      top: 1.6rem;
    }
  }

  //parent
  @keyframes anim_parent {
    0% {
      top: 1.613333rem;
    }

    50% {
      top: 1.713333rem;
    }

    100% {
      top: 1.613333rem;
    }
  }

  @-moz-keyframes anim_parent {
    0% {
      top: 1.613333rem;
    }

    50% {
      top: 1.713333rem;
    }

    100% {
      top: 1.613333rem;
    }
  }

  @-webkit-keyframes anim_parent {
    0% {
      top: 1.613333rem;
    }

    50% {
      top: 1.713333rem;
    }

    100% {
      top: 1.613333rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main.vue